// Auto-generated - DO NOT EDIT
export const pathMapping = {
  "get:/wello/v1/auth/tour/article/{articleId}/feedback": "findArticleFeedback",
  "post:/wello/v1/auth/tour/festival/{tourId}/review": "saveTourReview",
  "get:/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}": "findTourReview",
  "put:/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}": "updateTourReview",
  "delete:/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}": "deleteTourReview",
  "get:/wello/v2/auth/benefit-attendance": "findBenefitAttendanceStatus",
  "post:/wello/v2/auth/benefit-attendance": "checkInBenefitAttendance",
  "get:/wello/v2/auth/benefit-lottery/entry-availability": "findLotteryEntryAvailability",
  "post:/wello/v2/auth/benefit-notification/application-info": "saveBenefitNotificationApplicationInfo",
  "get:/wello/v2/auth/benefit-notification/application-results-url": "getBenefitNotificationApplicationResultsUrl",
  "get:/wello/v2/auth/benefit-notification/fit-analysis": "getBenefitNotificationFitAnalysis",
  "get:/wello/v2/auth/benefit-notification/fit-analysis-result": "getBenefitNotificationFitAnalysisResult",
  "get:/wello/v2/auth/benefit-notification/main-info": "getBenefitNotificationMainInfo",
  "get:/wello/v2/auth/benefit-notification/privacy-policy-url": "getBenefitNotificationPrivatePolicyUrl",
  "get:/wello/v2/auth/benefit-notification/privacy-usage-url": "getBenefitNotificationPrivacyUsageUrl",
  "get:/wello/v2/auth/benefit-notification/public-service-detail-url": "getBenefitNotificationPublicServiceDetailUrl",
  "get:/wello/v2/auth/benefit-notification/service-usage-agreement-management-url": "getBenefitNotificationServiceUsageAgreementManagementUrl",
  "get:/wello/v2/auth/benefit-notification/service-usage-agreement-url": "getBenefitNotificationServiceUsageAgreementUrl",
  "get:/wello/v2/auth/benefit-notification/situation-management-url": "getBenefitNotificationSituationManagementUrl",
  "get:/wello/v2/auth/benefit-notification/term-service-url": "getBenefitNotificationTermServiceUrl",
  "get:/wello/v2/auth/benefit-tickets": "findBenefitTicketBalance",
  "get:/wello/v2/auth/benefit-tickets/lucky-ticket": "findLuckyTicketAvailability",
  "post:/wello/v2/auth/certification/cellphone": "sendCertificationCellphone",
  "post:/wello/v2/auth/certification/check": "certificationCheck",
  "get:/wello/v2/auth/community/wello-news/feedback/{communityIdIdx}": "feedbackCommunityWelloNews",
  "get:/wello/v2/auth/community/wello-news/{communityIdIdx}": "getCommunityWelloNews",
  "post:/wello/v2/auth/community/{communityId}/report": "reportCommunity",
  "get:/wello/v2/auth/contents/feedback/{bestContentsId}": "bestContentsFeedback",
  "get:/wello/v2/auth/cs/inquiry": "inquiryList",
  "post:/wello/v2/auth/cs/inquiry": "saveInquiry1",
  "get:/wello/v2/auth/cs/inquiry/{inquiryId}": "getInquiry",
  "get:/wello/v2/auth/emergency-room": "getEmergencyRoomList",
  "get:/wello/v2/auth/emergency-room/{emergencyRoomId}": "getEmergencyRoom",
  "post:/wello/v2/auth/external/adpopcorn-ssp": "saveAdpopcornSspHistory",
  "post:/wello/v2/auth/feed": "getFeedList",
  "post:/wello/v2/auth/home-donation-event": "applyHomeDonationEvent",
  "get:/wello/v2/auth/home-donation-event-history": "getEventHistoryList",
  "get:/wello/v2/auth/home-donation-event-history/invitee-event/received": "getInviteeEventReceived",
  "get:/wello/v2/auth/home-donation-event-history/summary": "getMyInviteEventHistorySummary",
  "get:/wello/v2/auth/home-donation-event/is-progressing": "isEventInProgress",
  "get:/wello/v2/auth/home-donation-event/reward": "findEventRewardList",
  "get:/wello/v2/auth/home-donation/certificate": "getHomeInstitutionCertificate",
  "get:/wello/v2/auth/home-donation/certificate/latest": "getLatestHomeInstitutionCertificate",
  "get:/wello/v2/auth/home-donation/epay-no/{epayNo}": "getHomeDonationHistory",
  "get:/wello/v2/auth/home-donation/history": "getHomeDonationHistoryList",
  "get:/wello/v2/auth/home-donation/my": "getMyDonationInfo",
  "get:/wello/v2/auth/home-inquiry": "getHomeInquiryList",
  "post:/wello/v2/auth/home-inquiry": "saveHomeInquiry1",
  "get:/wello/v2/auth/home-inquiry/my": "getHomeInquiryMyList",
  "get:/wello/v2/auth/home-inquiry/{homeInquiryId}": "getHomeInquiry",
  "put:/wello/v2/auth/home-inquiry/{homeInquiryId}": "saveHomeInquiry",
  "delete:/wello/v2/auth/home-inquiry/{homeInquiryId}": "deleteHomeInquiry",
  "post:/wello/v2/auth/home-love/donation/before-complete": "beforeCompleteDonation",
  "post:/wello/v2/auth/home-love/donation/check": "checkDonationAvailable",
  "post:/wello/v2/auth/home-love/donation/complete": "completeDonation",
  "get:/wello/v2/auth/home-love/donation/latest-complete": "latestCompleteDonation",
  "post:/wello/v2/auth/home-love/donation/process": "processDonation",
  "post:/wello/v2/auth/home-love/member": "createMember",
  "get:/wello/v2/auth/home-love/member/check": "checkMember",
  "get:/wello/v2/auth/home-notice": "getHomeNoticeList",
  "get:/wello/v2/auth/home/delivery": "getDeliveryAddressList",
  "post:/wello/v2/auth/home/delivery": "createDeliveryAddress",
  "get:/wello/v2/auth/home/delivery/primary": "getPrimaryDeliveryAddress",
  "get:/wello/v2/auth/home/delivery/{addressId}": "getDeliveryAddress",
  "put:/wello/v2/auth/home/delivery/{addressId}": "updateDeliveryAddress",
  "delete:/wello/v2/auth/home/delivery/{addressId}": "deleteDeliveryAddress",
  "get:/wello/v2/auth/home/donation-business-comment": "getDonationBusinessCommentList",
  "post:/wello/v2/auth/home/donation-business-comment": "saveDonationBusinessComment",
  "put:/wello/v2/auth/home/donation-business-comment": "updateDonationBusinessComment",
  "delete:/wello/v2/auth/home/donation-business-comment": "deleteDonationBusinessComment",
  "post:/wello/v2/auth/home/donation/reservation": "createDonationReservation",
  "get:/wello/v2/auth/home/event/december/random-ticket-count": "getDecemberRandomTicketCount",
  "put:/wello/v2/auth/home/event/december/random-ticket/{randomTicketId}": "openRandomTicket",
  "get:/wello/v2/auth/home/gift-review": "getGiftOrderProductReviewList",
  "post:/wello/v2/auth/home/gift-review": "saveGiftOrderProductReview",
  "put:/wello/v2/auth/home/gift-review": "updateGiftOrderProductReview",
  "get:/wello/v2/auth/home/gift-review/my": "getMyGiftOrderProductReviewList",
  "get:/wello/v2/auth/home/gift-review/{reviewId}": "getGiftOrderProductReview",
  "delete:/wello/v2/auth/home/gift-review/{reviewId}": "removeGiftOrderProductReview",
  "get:/wello/v2/auth/home/gift/order": "getGiftOrderHistoryList",
  "get:/wello/v2/auth/home/gift/order/{orderId}": "getGiftOrderHistory",
  "put:/wello/v2/auth/home/gift/order/{orderId}/address": "updateGiftOrderAddress",
  "get:/wello/v2/auth/home/gift/order/{orderId}/delivery": "getDeliveryTracking2",
  "put:/wello/v2/auth/home/gift/order/{orderId}/status": "updateGiftOrderStatus",
  "get:/wello/v2/auth/home/institution-event": "getHomeInstitutionEventList",
  "get:/wello/v2/auth/home/institution-event/ordered": "getOrderedHomeInstitutionEventList",
  "get:/wello/v2/auth/home/institution/policy": "getHomeInstitutionPolicyList",
  "get:/wello/v2/auth/hometown-news/feedback/{hometownNewsId}": "hometownNewsFeedback",
  "get:/wello/v2/auth/hometown-news/{hometownNewsIdIdx}": "hometownNews",
  "delete:/wello/v2/auth/kakao-bank/member": "resignMember1",
  "post:/wello/v2/auth/kb": "sendPinkey",
  "get:/wello/v2/auth/kosaf/confirm-household-info-agreement": "confirmHouseholdInfoAgreement",
  "get:/wello/v2/auth/local-market-orders": "findAllOrders",
  "get:/wello/v2/auth/local-market-orders/by-number/{orderNo}": "findOrderByNumber",
  "get:/wello/v2/auth/local-market-orders/unified": "findUnifiedOrders",
  "get:/wello/v2/auth/local-market-orders/{orderId}": "findOrder",
  "put:/wello/v2/auth/local-market-orders/{orderId}/cancel": "cancelOrder",
  "put:/wello/v2/auth/local-market-orders/{orderId}/confirm": "confirmPurchase",
  "get:/wello/v2/auth/local-market-orders/{orderId}/deliveries/{deliveryId}/tracking": "getDeliveryTracking1",
  "put:/wello/v2/auth/local-market-orders/{orderId}/delivery-address": "updateAllDeliveryAddress",
  "put:/wello/v2/auth/local-market-orders/{orderId}/order-products/cancel": "cancelOrderProducts",
  "post:/wello/v2/auth/local-market-orders/{orderId}/order-products/exchange": "exchangeOrderProducts",
  "post:/wello/v2/auth/local-market-orders/{orderId}/order-products/return": "returnOrderProducts",
  "post:/wello/v2/auth/local-market-orders/{orderId}/products/{orderProductId}/return": "requestReturn",
  "put:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/cancel": "cancelOrderProduct",
  "put:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/cancel-all": "cancelProduct",
  "put:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/confirm": "confirmOrderProduct",
  "post:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/exchange-all": "exchangeProduct",
  "get:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/order-items": "getOrderItemsForAction",
  "get:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/refund-estimate": "getRefundEstimate",
  "get:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/refund-info": "getProductRefundInfo",
  "post:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/return-all": "returnProduct",
  "get:/wello/v2/auth/local-market-orders/{orderId}/receipt": "getReceipt",
  "get:/wello/v2/auth/local-market-orders/{orderId}/refund-info": "getRefundInfo",
  "put:/wello/v2/auth/local-market-orders/{orderId}/return/{returnId}/cancel": "cancelReturn",
  "get:/wello/v2/auth/local-market-orders/{orderId}/transaction-statement": "getTransactionStatement",
  "put:/wello/v2/auth/local-market-orders/{orderId}/vendors/{vendorId}/delivery-address": "updateVendorDeliveryAddress",
  "post:/wello/v2/auth/local-market/before-orders": "createBeforeOrder",
  "get:/wello/v2/auth/local-market/before-orders/{beforeOrderId}": "getBeforeOrder",
  "post:/wello/v2/auth/local-market/before-orders/{beforeOrderId}/dummy-complete": "dummyComplete",
  "get:/wello/v2/auth/local-market/cart-items": "findCartItems",
  "post:/wello/v2/auth/local-market/cart-items": "saveCartItem",
  "delete:/wello/v2/auth/local-market/cart-items": "deleteCartItems",
  "get:/wello/v2/auth/local-market/cart-items/coupon-available": "findCouponAvailable",
  "get:/wello/v2/auth/local-market/cart-items/product-options/{productId}": "getProductOptionsById",
  "delete:/wello/v2/auth/local-market/cart-items/{cartItemId}": "deleteCartItem",
  "put:/wello/v2/auth/local-market/cart-items/{cartItemId}/option": "updateOption",
  "put:/wello/v2/auth/local-market/cart-items/{cartItemId}/quantity": "updateQuantity",
  "put:/wello/v2/auth/local-market/checkouts/{beforeOrderId}/checkout": "checkout",
  "get:/wello/v2/auth/local-market/coupons/applicable": "findApplicableCoupons",
  "post:/wello/v2/auth/local-market/coupons/applicable-for-products": "findApplicableCouponsForProducts",
  "get:/wello/v2/auth/local-market/coupons/available": "findAvailableCoupons",
  "post:/wello/v2/auth/local-market/coupons/download-all": "downloadAllCoupons",
  "get:/wello/v2/auth/local-market/coupons/downloadable": "findDownloadableCoupons",
  "get:/wello/v2/auth/local-market/coupons/downloadable/exists": "existsDownloadableCoupon",
  "get:/wello/v2/auth/local-market/coupons/my": "findMyCoupons",
  "post:/wello/v2/auth/local-market/coupons/{couponId}/download": "downloadCoupon",
  "get:/wello/v2/auth/local-market/my/reviews": "findMyReviews",
  "post:/wello/v2/auth/local-market/my/reviews/orders/{orderId}/products/{productId}": "saveReview",
  "get:/wello/v2/auth/local-market/my/reviews/orders/{orderId}/products/{productId}/form": "getReviewForm",
  "get:/wello/v2/auth/local-market/my/reviews/{reviewId}": "findMyReview",
  "put:/wello/v2/auth/local-market/my/reviews/{reviewId}": "updateMyReview",
  "delete:/wello/v2/auth/local-market/my/reviews/{reviewId}": "deleteMyReview",
  "get:/wello/v2/auth/local-market/payment-methods": "findSimplePayMethods",
  "post:/wello/v2/auth/local-market/payments/approve": "approvePayment",
  "post:/wello/v2/auth/local-market/payments/cancel": "cancelOrder1",
  "get:/wello/v2/auth/local-market/payments/config": "findPaymentConfig",
  "get:/wello/v2/auth/local-market/payments/terms": "findAllTerms",
  "get:/wello/v2/auth/local-market/payments/terms/{termsType}": "findTerms",
  "post:/wello/v2/auth/local-market/products/{productId}/inquiries": "saveInquiry",
  "delete:/wello/v2/auth/local-market/products/{productId}/inquiries/{inquiryId}": "deleteInquiry",
  "get:/wello/v2/auth/localfesta/participant": "getLocalfestaParticipantInfo",
  "post:/wello/v2/auth/localfesta/participant": "saveLocalfestaParticipant",
  "put:/wello/v2/auth/localfesta/participant/entry": "updateLocalfestaParticipantEntry",
  "post:/wello/v2/auth/member": "fileUpload1",
  "delete:/wello/v2/auth/member": "resignMember",
  "post:/wello/v2/auth/member-filter/fit": "putFitFilter",
  "post:/wello/v2/auth/member-filter/fit-new": "saveFitFilter",
  "get:/wello/v2/auth/member-filter/interest": "interestFilter",
  "post:/wello/v2/auth/member-filter/interest": "saveInterestFilter",
  "post:/wello/v2/auth/member-filter/kb": "saveKbFilter",
  "post:/wello/v2/auth/member-filter/region": "noticeList",
  "get:/wello/v2/auth/member-filter/required": "requiredFilter",
  "get:/wello/v2/auth/member-identity": "findMemberIdentity",
  "post:/wello/v2/auth/member-oauth/logout": "logoutMember",
  "get:/wello/v2/auth/member-oauth/my-info": "getMember",
  "get:/wello/v2/auth/member-term-agreement": "getMemberTermAgreementByAgreementType",
  "post:/wello/v2/auth/member-term-agreement": "saveOrUpdateMemberTermAgreement",
  "post:/wello/v2/auth/member-verification": "getLatestCompletedCi",
  "get:/wello/v2/auth/member-verification/check": "getMemberVerificationId",
  "post:/wello/v2/auth/member-verification/decrypt": "decryptMemberVerification",
  "post:/wello/v2/auth/member-verification/info": "getLatestCompleted",
  "get:/wello/v2/auth/member-verification/info/detail": "getMemberDetailInfo",
  "get:/wello/v2/auth/member-wello/block": "getWelloMemberBlockList",
  "post:/wello/v2/auth/member-wello/block/by-community/{communityId}": "blockWelloMemberByCommunity",
  "delete:/wello/v2/auth/member-wello/block/{blockedMemberId}": "deleteMemberWelloBlock",
  "get:/wello/v2/auth/member-wello/location-service-consent": "getLocationServiceConsent",
  "put:/wello/v2/auth/member-wello/location-service-consent": "updateLocationServiceConsent",
  "get:/wello/v2/auth/member-wello/private_data_consent": "getPrivateDataConsent",
  "put:/wello/v2/auth/member-wello/private_data_consent": "updatePrivateDataConsent",
  "get:/wello/v2/auth/member/action-count": "getActionCount",
  "get:/wello/v2/auth/member/content-count": "memberContentCount",
  "get:/wello/v2/auth/member/invited-member-count": "getInvitedMemberCount",
  "post:/wello/v2/auth/member/kb-member-check": "kbMemberCheck",
  "put:/wello/v2/auth/member/message-receive": "messageReceive",
  "get:/wello/v2/auth/member/neighbor/policy": "memberNeighborPolicyList",
  "get:/wello/v2/auth/member/peer-group/policy": "memberPeerGroupPolicyList",
  "get:/wello/v2/auth/member/policy/provision-type-count": "memberPolicyList",
  "get:/wello/v2/auth/member/profile": "member",
  "post:/wello/v2/auth/member/profile": "saveMemberNickName",
  "put:/wello/v2/auth/member/profile": "updateMemberNickName",
  "get:/wello/v2/auth/member/recent/recommend/policy": "memberRecommendPolicyByRecentList",
  "get:/wello/v2/auth/member/social-accounts": "memberSocialAccounts",
  "get:/wello/v2/auth/member/user-property": "userProperty",
  "put:/wello/v2/auth/member/verification": "updateMemberVerification",
  "post:/wello/v2/auth/member/wishlist": "saveWishlist",
  "delete:/wello/v2/auth/member/wishlist": "deleteWishlist",
  "get:/wello/v2/auth/member/wishlist/best-contents": "bestContentsWishlist",
  "get:/wello/v2/auth/member/wishlist/community/wello-news": "getCommunityWelloNewsWishlist",
  "get:/wello/v2/auth/member/wishlist/emergency-room": "getEmergencyRoomWishlist",
  "get:/wello/v2/auth/member/wishlist/hometown-news": "hometownNewsWishlist",
  "get:/wello/v2/auth/member/wishlist/policy": "metaPolicyWishlist",
  "get:/wello/v2/auth/member/wishlist/tour-festival": "getTourFestivalWishlist",
  "put:/wello/v2/auth/message-reject/member-wello": "rejectMessage",
  "post:/wello/v2/auth/nice-safe-key": "sendNiceSafeKey",
  "get:/wello/v2/auth/nice-safe-key/check-plus-send-result": "checkPlusSendResult",
  "get:/wello/v2/auth/nice-safe-key/check-plus_fail": "checkPlusFail",
  "post:/wello/v2/auth/nonsan-roulette/draw": "drawNonsanRoulette",
  "get:/wello/v2/auth/nonsan-roulette/status": "findNonsanRouletteStatus",
  "get:/wello/v2/auth/point": "getDetailPointBalance",
  "get:/wello/v2/auth/point-market/order": "getPointMarketOrderList",
  "post:/wello/v2/auth/point-market/order/payments": "payPointMarketOrder",
  "get:/wello/v2/auth/point-market/order/preview": "getPointMarketOrderPreview",
  "post:/wello/v2/auth/point-market/order/reissue-coupon": "reissueCoupon",
  "put:/wello/v2/auth/point-market/order/status": "updatePointMarketOrderStatusList",
  "post:/wello/v2/auth/point-market/order/{orderIdIdx}/coupon": "issuePointMarketCoupon",
  "post:/wello/v2/auth/point-market/product/{productIdIdx}/feedback": "feedbackPointMarketProduct",
  "get:/wello/v2/auth/point/attendance": "getListPointAttendance",
  "post:/wello/v2/auth/point/attendance": "saveTodayAttendance",
  "post:/wello/v2/auth/point/coupang-banner": "rewardCoupangBannerClick",
  "get:/wello/v2/auth/point/coupang-banner/status": "getCoupangBannerStatus",
  "get:/wello/v2/auth/point/history": "getListPointHistory",
  "get:/wello/v2/auth/policy-apply/check": "checkWelloPolicyApply",
  "get:/wello/v2/auth/policy-apply/history": "getWelloPolicyApplyList",
  "get:/wello/v2/auth/policy-apply/history/count": "getWelloPolicyApplyCount",
  "post:/wello/v2/auth/policy-apply/report": "saveReport",
  "get:/wello/v2/auth/policy/feedback/{policyId}": "metaPolicyFeedback",
  "get:/wello/v2/auth/policy/interest-policy": "getInterestPolicyList",
  "get:/wello/v2/auth/poll/{pollId}": "getPoll",
  "get:/wello/v2/auth/poll/{pollId}/result": "getPollResult",
  "post:/wello/v2/auth/poll/{pollId}/vote": "createPollVote",
  "get:/wello/v2/auth/poll/{pollId}/voted": "checkVoted",
  "get:/wello/v2/auth/recommend-policy": "recommendPolicyList",
  "post:/wello/v2/auth/s3": "fileUpload",
  "put:/wello/v2/auth/s3": "updateFileTempSaveYn",
  "delete:/wello/v2/auth/s3": "fileDelete",
  "post:/wello/v2/auth/s3/copy": "fileCopy",
  "get:/wello/v2/auth/s3/decryption": "fileDecryptionDownload",
  "post:/wello/v2/auth/s3/re": "fileReUpload",
  "put:/wello/v2/auth/s3/rename": "fileRename",
  "get:/wello/v2/auth/tour/feedback/{tourId}": "findTourFeedback",
  "get:/wello/v2/auth/wello-app-push": "getWebWelloAppPushList",
  "put:/wello/v2/auth/wello-app-push": "updateWelloAppPushRead",
  "get:/wello/v2/auth/wello-comment": "getWelloCommentList",
  "post:/wello/v2/auth/wello-comment": "saveWelloComment",
  "post:/wello/v2/auth/wello-comment-report": "saveWelloCommentReport",
  "get:/wello/v2/auth/wello-comment/live": "getLiveWelloCommentList",
  "get:/wello/v2/auth/wello-comment/my": "getMyWelloCommentList",
  "get:/wello/v2/auth/wello-comment/{welloCommentId}": "getMetaPolicyCommentList",
  "put:/wello/v2/auth/wello-comment/{welloCommentId}": "updateWelloComment",
  "put:/wello/v2/auth/wello-comment/{welloCommentId}/delete": "deleteWelloComment",
  "post:/wello/v2/auth/wello-device-info": "saveWelloDeviceInfo",
  "post:/wello/v2/auth/wello-like": "saveWelloLike",
  "delete:/wello/v2/auth/wello-like": "deleteWelloLike",
  "get:/wello/v2/auth/wello-like/my": "getListLikeContents",
  "get:/wello/v2/auth/wello-like/my/type": "getListLikeContentsType",
  "get:/wello/v2/auth/wello-policy-code/reverse-geocoding": "authReverseGeocoding",
  "post:/wello/v2/auth/wello-track": "saveWelloTracking",
  "get:/wello/v2/auth/wello-trend-monitor/blocklist": "findBlocklist",
  "post:/wello/v2/auth/wello-trend-monitor/blocklist": "saveBlocklist",
  "delete:/wello/v2/auth/wello-trend-monitor/blocklist/{blocklistId}": "deleteBlocklist",
  "get:/wello/v3/auth/account-integration/candidates": "candidates",
  "post:/wello/v3/auth/account-integration/merge": "merge",
  "get:/wello/v3/auth/local-market-orders/{orderId}/deliveries/{deliveryId}/tracking": "getDeliveryTracking"
} as const;
